import clsx from "clsx";
import styles from "./checkbox.module.css";

export type CheckboxProps = {
  label: any;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isValid?: boolean;
  disabled?: boolean;
  validate: boolean;
  className?: string;
};

const UI = ({
  label,
  checked,
  onChange,
  isValid,
  disabled,
  validate,
  className,
}: CheckboxProps) => {
  return (
    <>
      <label className={clsx(styles.checkbox, className)}>
        <input
          disabled={disabled}
          type="checkbox"
          checked={checked}
          onChange={onChange}
        />

        <div
          className={`${styles.fauxInput} ${checked && styles.checked} ${disabled && styles.disabled}`}
        />

        <span>{label}</span>

        {isValid || !validate ? null : (
          <p className={styles.error}>This is required</p>
        )}
      </label>
    </>
  );
};

export default UI;
